/* eslint-disable import/no-extraneous-dependencies */

import Vue from 'vue';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import './assets/styles/custom-bulma.scss';
import './assets/styles/styles.css';
import './assets/styles/themes.css';
import PortalVue from 'portal-vue';
import VeeValidate from 'vee-validate';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './components/base';
import './utils/directives';
import './utils/froala';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import space_permission from './utils/space_pemission';
import { copy } from './utils/helpers';
import { space_topic_permission } from './utils/topic_permission';

Vue.use(PortalVue);
Vue.use(VeeValidate);

Vue.mixin({
    methods: { space_permission, space_topic_permission, copy },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate() {
        this.$store.dispatch('configurations/get');
    },
}).$mount('#app');
